import script from "./ExcellenceAndDiscountPromotion.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcellenceAndDiscountPromotion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__